module.exports = __webpack_public_path__ + "static/img/LoginSuccessLogo.2222db83.png";